<template>
  <div class="rounded-[var(--radius-lg)] border border-border bg-card transition-shadow "
    :class="{ 'cursor-pointer hover:shadow-[var(--shadow-md)] hover:-translate-y-[1px] duration-500 ease-out': clickable }"
    @click="clickable ? $emit('click') : undefined">
    <slot />
  </div>
</template>

<script setup lang="ts">
defineProps<{ clickable?: boolean }>()
defineEmits<{ click: [] }>()
</script>
